// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.payment_result.final .cancel[data-v-5032bbbd] {text-decoration:line-through; color: var(--text-sub-color);}\r\n", ""]);
// Exports
module.exports = exports;
